import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Input, ViewEncapsulation } from '@angular/core';
import { InterestTypeEnum } from '@partners/constants';
import { isEmpty, TNumericFormatPattern, ToMoneyPipe } from '@partners/utils';
import { NumericLabelComponent } from '../numeric-label';

@Component({
  standalone: true,
  selector: 'interest-label',
  template: `
    @switch(interestType()){ 
      @case(interestTypeEnum.fixedLinked){
        <numeric-label
          [class]="interestClass"
          [value]="interestValue"
          [presetFormat]="'percent'"
          [formatPattern]="interestPattern"
        ></numeric-label>
      } 
      @case (interestTypeEnum.variable) {
        <span class="prime-gap">
          <span [class]="interestClass">
            <span>(</span>
            <numeric-label
              [class]="interestClass"
              [value]="interestValue"
              [presetFormat]="'percent'"
              [formatPattern]="interestPattern"
            ></numeric-label>
            <span>)</span>
          </span>

          <span [class]="primeGapClass">
            <numeric-label
              [class]="primeGapClass"
              [value]="primeGapValue"
              [isAbsoluteMode]="true"
              [presetFormat]="'percent'"
              [formatPattern]="primeGapPattern"
            ></numeric-label>
            <span *ngIf="!isNegativeGap">+</span>
            <span *ngIf="isNegativeGap">-</span>
            <span>P</span>
          </span>
        </span>
      } 
   }
  `,
  host: {
    class: 'interest-label'
  },
  imports: [CommonModule, NgIf, NumericLabelComponent, ToMoneyPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class InterestLabelComponent {
  @Input()
  interestValue: string | number;

  @Input()
  interestClass: string = 'interest';

  @Input()
  primeGapClass: string = 'prime-gap';

  @Input()
  interestPattern: TNumericFormatPattern = '1.1-2';

  @Input()
  primeGapPattern: TNumericFormatPattern = '1.1-2';

  @Input()
  primeGapValue: string | number;

  interestType = input.required<InterestTypeEnum>();

  interestTypeEnum = InterestTypeEnum;

  get isNegativeGap(): boolean {
    if (isEmpty(this.primeGapValue)) {
      return false;
    }
    return parseFloat(this.primeGapValue.toString()) < 0;
  }

  constructor() {}
}
